import { AgentComponentType } from '@reach/shared-types/agent-components';
import { STATUS_COPY } from '../agents-copy';
import { StatusNote } from '../StatusNote';
import { useTemplateComponents } from '../useTemplateComponents';
import { TemplateSection } from './TemplateSection';

const TEMPLATE_SECTION_ORDER = [
  AgentComponentType.GUIDANCE,
  AgentComponentType.SKILL,
  AgentComponentType.ESCALATION,
];

interface TemplateComponentsProps {
  templateId: string;
}

export const TemplateComponents = ({ templateId }: TemplateComponentsProps) => {
  const { data: templateComponents, isLoading } = useTemplateComponents(templateId);

  if (isLoading) {
    return <StatusNote>{STATUS_COPY.loading}</StatusNote>;
  }
  if (!templateComponents) {
    return (
      <StatusNote tone="error">{STATUS_COPY.loadError('The components on this template')}</StatusNote>
    );
  }
  const componentsOfType = (type: AgentComponentType) =>
    templateComponents.filter(component => component.type === type);
  return (
    <>
      {TEMPLATE_SECTION_ORDER.map(type => (
        <TemplateSection
          key={type}
          templateId={templateId}
          type={type}
          components={componentsOfType(type)}
        />
      ))}
    </>
  );
};
